import { Text, Box } from "@hightouch/htui";

import { useNavWidth } from "src/contexts/nav-width-context";

export type Props = {
  children: string;
};

export const navItemTransitions = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "easeOutQuad",
};

export const NavItemText = ({ children }: Props) => {
  const { isNavOpen } = useNavWidth();

  if (!isNavOpen) {
    return null;
  }

  return (
    <Box
      as={Text}
      color="inherit"
      size="md"
      fontWeight="medium"
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      {children}
    </Box>
  );
};
